<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-20 10:27:47
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-30 10:57:19
 * @FilePath: /wemeet-admin-new/src/views/marketing/components/addGroup.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form ref="formRef" :model="form" :rules="rules">
      <el-form-item label="群体名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入群体名称" />
      </el-form-item>
    </el-form>

    <el-row>
      <el-col :span="12">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="展会信息" name="first">
            <el-tabs v-model="subactiveName" type="border-card">
              <el-tab-pane label="报名展会" name="first">
                <div style="display: flex; justify-content: space-between">
                  <el-button :icon="Plus" type="primary" @click="addExhItem">添加展会</el-button>
                  <div v-if="formItem.length > 1">
                    <span style="margin-right: 5px">组合筛选:</span>
                    <el-select v-model="condition" placeholder="请输入组合筛选条件" @change="changeCondition">
                      <el-option
                        v-for="sitem in conditionList"
                        :key="sitem.value"
                        :label="sitem.label"
                        :value="sitem.value"
                      />
                    </el-select>
                  </div>
                </div>
                <el-form :model="exhInfo">
                  <el-form-item
                    v-for="(item, index) in formItem"
                    :key="index"
                    label="报名展会"
                    style="margin-top: 20px"
                  >
                    <el-select
                      v-model="item.value"
                      :disabled="item.isCheck"
                      filterable
                      placeholder="请输入展会名称"
                      @change="changeSelect(item)"
                    >
                      <el-option
                        v-for="sitem in exhList"
                        :key="sitem.code"
                        :label="sitem.meetingName"
                        :value="sitem.code"
                      />
                    </el-select>
                    <el-button :icon="Select" style="margin-left: 5px" type="success" @click="confirmExhItem(item)" />
                    <el-button v-if="item.isCheck" :icon="Delete" type="danger" @click="delExhItem(item, index)" />
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="12">
        <el-card style="max-width: 480px">
          <template #header>
            <div class="card-header">
              <span>已选标签</span>
            </div>
          </template>
          <p>请选择左侧的标签，筛选人群</p>
          <el-card>
            <template #header>
              <div style="display: flex; justify-content: space-between">
                <span>报名展会</span>
                <span v-if="formItem.length > 1">{{ conditionMap[condition] }}</span>
              </div>
            </template>
            <ul class="ulBox">
              <li v-for="(item, index) in formItem" :key="index">
                <div v-if="item.isCheck">{{ getMeetName(item.value) }}</div>
                <el-button v-if="item.isCheck" :icon="Delete" type="danger" @click="delExhItem(item, index)" />
              </li>
            </ul>
          </el-card>
          <div>筛选人数: {{ userNum }}人</div>
        </el-card>
      </el-col>
    </el-row>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">添加</el-button>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import {
    getRegisterConfigList,
    dataGetB,
    dataExportB,
    exShelfAndUnshelfList,
    addEnterpriseMarketingAddDelivery,
    getEnterpriseMarketingQueryUsernum,
  } from '@/api/exhibitionManage'
  import { parseTime } from '@/utils/index'
  import { Delete, Plus, Search, Select } from '@element-plus/icons'
  export default defineComponent({
    name: 'EditConfigDrawer',

    setup(props, { emit }) {
      /**
       * @description: cover主k 自定义校验
       * @return {*}
       */

      const { proxy } = getCurrentInstance()
      const state = reactive({
        form: {
          name: '',
        },
        dialogFormVisible: false,
        activeName: 'first',
        subactiveName: 'first',
        direction: 'rtl',
        size: '60%',
        pararms: {
          type: 'MEETING_REGISTER_REPORT',
        },
        title: '筛选群体',
        tableData: [],
        isCheck: false,
        visible: false,
        checkRow: {},
        formItem: [
          {
            value: '',
            index: 0,
            isCheck: false,
          },
        ],
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入群体名称' }],
        },
        options: [],
        conditionMap: {
          AND: '全都报名过的',
          OR: '报名过其中一个的',
        },
        conditionList: [
          {
            value: 'AND',
            label: '全都报名过的',
          },
          {
            value: 'OR',
            label: '报名过其中一个的',
          },
        ],
        condition: 'AND',
        // exportLoading: false,
        exhList: [],
        formRef: null,
        userNum: 0,
      })

      // 打开
      const handleOpen = async (row = {}, title, type) => {
        state.dialogFormVisible = true
        const { data } = await exShelfAndUnshelfList({
          pageNum: 1,
          pageSize: 999,
        })
        console.log(data, 'ssss')
        state.exhList = data.data
      }
      const getMeetName = (val) => {
        let list = JSON.parse(JSON.stringify(state.exhList))
        let data = list.filter((v) => v.code == val)
        return data[0].meetingName
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const remoteMethod = (val) => {
        console.log(val)
      }

      const addExhItem = () => {
        if (state.formItem[state.formItem.length - 1].value == '') {
          proxy.$baseMessage('请选择展会', 'error')
          return false
        }
        if (!state.formItem[state.formItem.length - 1].isCheck) {
          proxy.$baseMessage('请点击确定展会', 'error')
          return false
        }
        state.formItem.push({
          value: '',
          index: state.formItem.length,
          isCheck: false,
        })
      }

      const confirmExhItem = (val) => {
        if (val.value) {
          val.isCheck = true
          handleUserNum()
        } else {
          proxy.$baseMessage('请选择展会', 'error')
        }

        console.log(val)
      }
      const handleUserNum = async () => {
        const params = {
          queryEnterpriseUserMeetingBos: {
            logic: state.condition,
            meetingCode: [],
          },
        }

        state.formItem.forEach((v) => {
          if (v.isCheck) {
            params.queryEnterpriseUserMeetingBos.meetingCode.push(v.value)
          }
        })

        if (params.queryEnterpriseUserMeetingBos.meetingCode.length == 0) {
          state.userNum = 0
          return false
        }
        const { data } = await getEnterpriseMarketingQueryUsernum(params)
        console.log(data, '===>>>')

        state.userNum = data
      }
      const delExhItem = async (val, index) => {
        val.value = ''
        if (index == 0) {
          val.isCheck = false
        } else {
          state.formItem.splice(index, 1)
        }

        handleUserNum()
      }

      const changeSelect = (val) => {
        console.log(val)
      }

      const handleClose = () => {
        state.formItem = [
          {
            value: '',
            index: 0,
            isCheck: false,
          },
        ]
        state.form.name = ''
        state.userNum = 0
        state.dialogFormVisible = false
      }

      const handleSave = async () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            if (state.formItem.length == 0) {
              proxy.$baseMessage('请至少选择一个展会，再提交确定', 'error')
              return false
            }
            console.log(state.formItem)
            let data = {
              logic: state.condition,
              name: state.form.name,
            }
            let conditionsList = []
            let num = 0
            state.formItem.forEach((v) => {
              if (v.isCheck) {
                num++
                let obj = {
                  value: '',
                  type: 'EXHIBITION',
                  valueName: '',
                }
                obj.value = v.value
                obj.valueName = getMeetName(v.value)
                conditionsList.push(obj)
              }
            })
            if (num == 0) {
              proxy.$baseMessage('请至少选择一个展会，再提交确定', 'error')
              return false
            }

            data.conditionsList = conditionsList

            const { data: res } = await addEnterpriseMarketingAddDelivery(data)
            try {
              proxy.$baseMessage('添加成功', 'success')
              emit('fetch-data', false)
              handleClose()
            } catch (e) {
              proxy.$baseMessage('添加失败', 'error')
            }
          }
        })
      }

      const changeCondition = () => {
        handleUserNum()
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleDate,
        remoteMethod,
        addExhItem,
        confirmExhItem,
        delExhItem,
        getMeetName,
        changeSelect,
        handleSave,
        Select,
        Delete,
        handleClose,
        changeCondition,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    width: 100%;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }

  .ulBox {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      margin-top: 10px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
</style>
